import { Box, Typography } from '@mui/material';
import ProjectMemberAllocationCard from './project-member-allocation-card';
import { useEffect } from 'react';
import { IProjectMembersAllocationData } from '../type';
import {
  calculateTotalCurrentAllocationHours,
  suggestedAllocationCalculate,
  suggestedAllocationListGenerate
} from '../../common/utils/helperFunctions';

export interface AllocationType {
  projectId: string;
  projectMemberId: string;
  suggestedAllocation: string;
  currentAllocation: string;
  projectName: string;
  colorCode: string;
}

interface GridProps {
  members: IProjectMembersAllocationData[];
  isAdd: boolean;
  unit: number;
  pendingRequest?: boolean;
  setSuggestedAllocation: (value: string) => void;
  setSuggestedAllocationList?: (value: AllocationType[]) => void;
  value?: string;
  isMaximumValue: boolean;
}

export const ProjectMemberAllocationGrid = ({
  members,
  isAdd,
  unit,
  setSuggestedAllocation,
  setSuggestedAllocationList,
  pendingRequest,
  value,
  isMaximumValue
}: GridProps): JSX.Element => {
  const totalCurrentAllocationHours =
    calculateTotalCurrentAllocationHours(members);

  const suggestedAllocationList: AllocationType[] =
    suggestedAllocationListGenerate(
      members,
      unit,
      value as string,
      isMaximumValue
    );
  useEffect(() => {
    setSuggestedAllocationList?.(suggestedAllocationList);
  }, [unit, value, isMaximumValue]);

  return (
    <>
      {members.length > 0 ? (
        <Box
          sx={{
            marginBottom: '10px'
          }}
        >
          {members.map((member: IProjectMembersAllocationData) => {
            const suggestedAllocationValue = suggestedAllocationCalculate(
              unit,
              value as string,
              member.hoursPerWeek
            );

            return (
              <Box key={member.id}>
                <ProjectMemberAllocationCard
                  pendingRequests={pendingRequest}
                  project={member.projectName}
                  currentAllocation={member.hoursPerWeek}
                  suggestedAllocation={
                    isMaximumValue &&
                    Number(value) + totalCurrentAllocationHours >= 40
                      ? member.hoursPerWeek
                      : suggestedAllocationValue.toString()
                  }
                  isAdd={isAdd}
                  colorCode={member.colorCode}
                  setSuggestedAllocation={setSuggestedAllocation}
                />
              </Box>
            );
          })}
        </Box>
      ) : (
        <>
          <Typography
            sx={{
              fontFamily: 'Be Vietnam Pro',
              fontSize: '16px',
              fontWeight: 400,
              color: '#1A1B1F',
              textAlign: 'center',
              marginBottom: '20px'
            }}
          >
            No current allocations
          </Typography>
        </>
      )}
    </>
  );
};
